import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Table from '@tables/table'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Grid, Button, Divider } from '@material-ui/core'
import { API } from '@const'
import * as utils from '@utils'

class WaterpoolRecordListDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'WaterpoolRecordListDialog', options)
        }
    }

    state = {
        input: {},
        dialogOpen: false,
        isLoading: false,
    }

    columns = [
        {
            field: 'record_type_translated',
            translate: {
                dataKey: 'record_type',
                tranKey: 'JackpotRecord',
            },
        },
        {
            field: 'money',
            render: (rowData) => {
                return (
                    <p
                        style={{
                            marginBottom: 0,
                            color: rowData.record_type === 'deposit' ? 'red' : '',
                        }}>
                        {utils.currencyFormatter(rowData.money)}
                    </p>
                )
            },
            customSort: (a, b) => {
                return a['money'] - b['money']
            },
        },
        { field: 'created_at', type: 'datetime' },
    ]

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {}

    OpenDialog(jackpot_id) {
        this.reset()
        setTimeout(() => this.queryData(jackpot_id))
        this.setState({ dialogOpen: true })
    }

    CloseDialog() {
        this.setState({ dialogOpen: false })
    }

    queryData = (jackpot_id) => {
        this.table.queryData({ jackpot_id: jackpot_id })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} scroll="body" fullWidth="true" maxWidth="sm">
                <DialogTitle>
                    {this.t('title', {
                        game_name: this.t('GameName.' + this.props.ownerState.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Table
                                ownerName="WaterpoolRecordListDialog"
                                columns={this.columns}
                                options={{
                                    // export: true,
                                    orderIdx: 2,
                                }}
                                onRef={(ref) => (this.table = ref)}
                                queryDataArgs={{
                                    apiPath: API.JACKPOT_RECORD_LIST,
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.setState({ dialogOpen: false })} color="primary">
                        {this.t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

WaterpoolRecordListDialog.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    ownerState: PropTypes.object,
}

const styles = (_theme) => ({})

export default hoc(styles)(WaterpoolRecordListDialog)
